export enum ApiQueryKeys {
  BRIEFS = 'briefs',
  PROJECTS = 'projects',
  PROJECT_DETAILED = 'project_detailed',
  SYNC_ERRORS = 'sync_errors',
}
